<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>薪资管理</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form
            :model="searchForm"
            :inline="true"
            class="demo-form-inline"
            size="small"
          >
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.TypeId"
                clearable
                placeholder="请选择薪酬体系"
                size="small"
              >
                <el-option
                  v-for="(item, index) in SalarySystemList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.RankID"
                clearable
                placeholder="请选择薪级"
                size="small"
              >
                <el-option
                  v-for="(item, index) in SalaryGradeList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.LevelID"
                clearable
                placeholder="请选择薪档"
                size="small"
              >
                <el-option
                  v-for="(item, index) in SalaryScaleList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="quotaSearch"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button type="primary" size="small" @click="quotaAdd"
                >添加薪资</el-button
              >
            </el-form-item>
            <el-form-item style="float:right">
              <el-button
                size="small"
                type="danger"
                @click="batchDeleteSalaryInfo()"
                >删除</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" ref="multipleTable" style="width: 100%">
            <el-table-column type="selection" width="50"></el-table-column>
             
            <el-table-column
              label="薪酬体系"
              :show-overflow-tooltip="true"
              min-width="10%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.SalaryType }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="薪级"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.RankName }}</span>
              </template>
            </el-table-column>

            <el-table-column
              label="薪档"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.LevelName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="薪酬标准"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.SalaryMoney }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              :show-overflow-tooltip="true"
              min-width="15%"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.CreateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="15%">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog title="添加信息" :visible.sync="dialogFormVisible">
      <!-- <el-form :model="dialogForm">
        <el-form-item label="名称">
          <el-input
            v-model="dialogForm.ClassName"
            autocomplete="off"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号">
          <el-input
            v-model="dialogForm.Sort"
            autocomplete="off"
            style="width:90%"
          ></el-input>
        </el-form-item>
      </el-form> -->

      <el-form
        :model="searchForm"
        :rules="rules"
        ref="searchForm"
        :inline="true"
        class="demo-ruleForm"
        size="small"
      >
        <el-row>
          <el-col :span="9">
            <el-form-item size="small" label="薪资标准" prop="SalaryMoney">
              <el-input v-model="searchForm.SalaryMoney"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.TypeId"
                clearable
                placeholder="请选择薪酬体系"
                @change="selectGetType"
                size="small"
                prop="TypeId"
              >
                <el-option
                  v-for="(item, index) in SalarySystemList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.RankID"
                clearable
                placeholder="请选择薪级"
                @change="selectGetRank"
                size="small"
                prop="RankID"
              >
                <el-option
                  v-for="(item, index) in SalaryGradeList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <el-select
                filterable
                v-model="searchForm.LevelID"
                clearable
                placeholder="请选择薪档"
                @change="selectGetLevel"
                size="small"
                prop="LevelID"
              >
                <el-option
                  v-for="(item, index) in SalaryScaleList"
                  :key="index"
                  :label="item.ClassName"
                  :value="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelDialog">取 消</el-button>
        <el-button type="primary" @click="handleChangeDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import {
  GetSalaryInfoList,
  DeleteSysitem,
  GetSingleSysItem,
  GetSingleSysItemSort,
  AddSysItem,
  GetSysItemListByParentID,
  AddSalaryInfo,
  GetSingleSalaryInfo,
  DeleteSalaryInfo
} from "../../until/ZeusApiSDK/Logic/SalaryStanded";
export default {
  data() {
    return {
      SalarySystemList: [], //薪酬体系集合
      SalaryGradeList: [], //薪级集合
      SalaryScaleList: [], //薪档集合
      searchName: "", //搜索信息
      currentUser: {}, //当前用户
      tableData: [],
      pageSizes: [10, 20, 30, 50, 100],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: true,
      visible: false,
      // 弹窗dialog
      dialogFormVisible: false,   
      searchForm: {
        TypeId: "", //薪酬体系Id
        SalaryType: "", //
        RankID: "", //薪级Id
        RankName: "",
        LevelID: "", //薪档Id
        LevelName: "",
        SalaryMoney: "" //薪资标准
      },
      //表单规则验证
      rules: {
        SalaryMoney: [
          { required: true, message: "请填写薪资标准", trigger: "blur" }
        ],
        TypeId: [
          { required: true, message: "请选择薪酬体系", trigger: "change" }
        ],
        RankID: [{ required: true, message: "请选择薪级", trigger: "change" }],
        LevelID: [{ required: true, message: "请选择薪档", trigger: "change" }]
      }
    }
  },
  created() {
    //获取当前用户信息
    this.getCurrentUser();
    this.GetSalaryInfoList();
    this.getSalarySysitemList();
    this.getSalaryGradeSysitemList();
    this.getSalaryScaleSysitemList();
  },
  methods: {
    //现有薪档
    selectGetLevel: async function(vId) {
      let obj = {};
      obj = await this.SalaryScaleList.find(item => {
        if (item.Id == vId) {
          this.searchForm.LevelName = item.ClassName;
        }
      });
    },
    //现有薪级
    selectGetRank: async function(vId) {
      let obj = {};
      obj = await this.SalaryGradeList.find(item => {
        if (item.Id == vId) {
          this.searchForm.RankName = item.ClassName;
        }
      });
    },
    //薪酬体系集合
    selectGetType: async function(vId) {
      let obj = {};
      obj = await this.SalarySystemList.find(item => {
        if (item.Id == vId) {
          this.searchForm.SalaryType = item.ClassName;
        }
      });
    },
    //获取薪酬体系集合，薪级集合，薪档集合等下拉列表
    getSalarySysitemList: async function() {
      await GetSysItemListByParentID("9").then(res => {
        this.SalarySystemList = res.Data.DataList;
        console.log(this.SalarySystemList);
      });
    },
    getSalaryGradeSysitemList: async function() {
      await GetSysItemListByParentID("3").then(res => {
        this.SalaryGradeList = res.Data.DataList;
      });
    },
    getSalaryScaleSysitemList: async function() {
      await GetSysItemListByParentID("4").then(res => {
        this.SalaryScaleList = res.Data.DataList;
      });
    },
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取薪资列表
    GetSalaryInfoList: async function() {
      this.loading = true;
      await GetSalaryInfoList(
        this.pageIndex,
        this.pageSize,
        this.searchForm.TypeId,
        this.searchForm.RankID,
        this.searchForm.LevelID
      ).then(res => {
        this.loading = false;
        console.log(res.Data.DataList);
        this.tableData = res.Data.DataList;
        this.totalCount = res.Data.totalCount;
      });
    },
    //批量删除操作
    batchDeleteSalaryInfo: function() {
      var userArray = this.$refs.multipleTable.selection;
      console.log(userArray);
      if (userArray <= 0) {
        this.$message({
          type: "error",
          message: "请选择操作项"
        });
        return false;
      }
      this.loading = true;
      var ids = "";
      userArray.forEach(item => {
        if (ids != "") {
          ids += item.Id + ",";
        } else {
          ids += item.Id;
        }
      });
      //删除操作
      DeleteSalaryInfo(this.currentUser.UserCode, ids).then(res => {
        if (res.Code == "1") {
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.GetSalaryInfoList();
        } else if (res.Code == "500") {
          this.$message({
            showClose: true,
            message: res.Msg,
            type: "error"
          });
          this.GetSalaryInfoList();
        } else {
          this.$message({
            showClose: true,
            message: "未知",
            type: "error"
          });
          this.GetSalaryInfoList();
        }
      });
    },
    quotaSearch() {
      // 初始化page页面
      this.initPage();
      // 执行搜索api
      this.GetSalaryInfoList();
    },
    quotaAdd() {
      this.getSalarySysitemList();
      this.getSalaryGradeSysitemList();
      this.getSalaryScaleSysitemList();
       // 关闭弹窗
      this.cancelDialog();
      // 打开弹窗
      this.openDialog();
    },
    handleEdit(index, row) {
    
      GetSingleSalaryInfo(row.Id).then(res => {
        if (res.Code == "200") {
           this.searchForm = {
             Id:res.Data.Id,
             TypeId: res.Data.TypeId, //名称
             RankID: res.Data.RankID, //父类ID
             LevelID: res.Data.LevelID ,//排序
             SalaryMoney:res.Data.SalaryMoney
           };
        }
      }),
        // 打开弹窗
        this.openDialog();
      // 点击取消 -> 弹窗清空
    },
    handleSizeChange(e) {
      this.initPage();
      this.pageSize = e;
      this.GetSalaryInfoList();
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.GetSalaryInfoList();
    },
    handleCancelDialog() {
      // 关闭弹窗
      this.cancelDialog();
    },
    handleChangeDialog() {
      //编辑或新增保存
      if (this.searchForm.Id == undefined) {
        this.searchForm.Id = "";
      }
      var data = {
        id: this.searchForm.Id,
        TypeId: this.searchForm.TypeId,
        SalaryType: this.searchForm.SalaryType,
        RankID: this.searchForm.RankID,
        RankName: this.searchForm.RankName,
        LevelID: this.searchForm.LevelID,
        LevelName: this.searchForm.LevelName,
        SalaryMoney: this.searchForm.SalaryMoney,
        UserCode: this.currentUser.UserCode
      };
      console.log(data);
      AddSalaryInfo(data).then(res => {
        if (res.Result == "1") {
          this.$message({
            showClose: true,
            message: "操作成功",
            type: "success"
          });
        }  else {
          this.$message({
            showClose: true,
            message: res.Message,
            type: "error"
          });
        }
        console.log(res.Msg);
        // 关闭弹窗
        this.cancelDialog();
      });
    },
    openDialog() {
      // 打开弹窗
      this.dialogFormVisible = true;
    },
    cancelDialog() {
      this.dialogFormVisible = false;
      this.searchForm = {
        Id: "",
        TypeId: "",
        SalaryType: "", 
        RankID: "",
        RankName: "",
        LevelID: "" ,
        LevelName: "",
        SalaryMoney: "" 
      };
    },
    initPage() {
      this.pageIndex = 1;
      this.pageSize = 10;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>
